import { Professional } from "../@data";
import { firestore } from "./firebase";
import {
  collection,
  addDoc,
  getDocs,
  getDoc,
  doc,
  updateDoc,
} from "firebase/firestore";
import { axiosApp } from "./index";
import { uploadFile } from "./storage";

export const createProfessional = async (
  professional: Omit<Professional, "id" | "createdAt" | "updatedAt"> & {
    imageFile?: File | null;
  }
): Promise<string> => {
  const now = Date.now();
  const docRef = await addDoc(collection(firestore, "professional"), {
    name: professional.name,
    description: professional.description,
    imageUrl: "", // será atualizado depois
    email: professional.email,
    lunchStart: professional.lunchStart,
    lunchEnd: professional.lunchEnd,
    enabled: true,
    createdAt: now,
    updatedAt: now,
  });

  let finalImageUrl = professional.imageUrl || "https://via.placeholder.com/80";
  if (professional.imageFile) {
    finalImageUrl = await uploadFile(
      professional.imageFile,
      `professionals/${docRef.id}`
    );
  }
  await updateDoc(docRef, { imageUrl: finalImageUrl });
  await axiosApp.post("/admin/professional", {
    email: professional.email,
    password: professional.password,
    uid: docRef.id,
  });
  return "Profissional criado com sucesso!";
};

export const getAllProfessionals = (): Promise<Professional[]> => {
  return new Promise((resolve, reject) => {
    getDocs(collection(firestore, "professional"))
      .then((querySnapshot) => {
        resolve(
          querySnapshot.docs.map(
            (doc) => ({ id: doc.id, ...doc.data() } as unknown as Professional)
          )
        );
      })
      .catch((error) => reject(error));
  });
};

export const getProfessionalById = (
  id: string
): Promise<Professional | null> => {
  return new Promise((resolve, reject) => {
    const docRef = doc(firestore, "professional", id);
    getDoc(docRef)
      .then((docSnap) => {
        if (docSnap.exists()) {
          resolve({
            id: docSnap.id,
            ...docSnap.data(),
          } as unknown as Professional);
        } else {
          resolve(null);
        }
      })
      .catch((error) => reject(error));
  });
};

export const updateProfessional = async (
  id: string,
  data: Partial<Omit<Professional, "id" | "createdAt" | "updatedAt">>
) => {
  const { email, password, ...basicData } = data;
  const docRef = doc(firestore, "professional", id);
  await updateDoc(docRef, {
    ...basicData,
    updatedAt: Date.now(),
  });
};

export const deleteProfessional = (id: string) => {
  return new Promise<void>((resolve, reject) => {
    axiosApp
      .delete(`/admin/professional/${id}`)
      .then(() => resolve())
      .catch((error) => reject(error?.response?.data));
  });
};

export const enableOrDisableProfessional = (id: string, enable: boolean) => {
  return new Promise<void>((resolve, reject) => {
    axiosApp
      .patch(`/admin/professional/${id}`, { enable })
      .then(() => resolve())
      .catch((error) => reject(error?.response?.data));
  });
};
